<iframe id="secondviewiframe" style="display: none" #secondViewIframe allow="camera; microphone"></iframe>
